// extracted by mini-css-extract-plugin
export var integrationButton = "_67-0";